import { connect } from 'react-redux';
import { logger } from '@fiverr-private/obs';
import { setSearchTerm } from '../../../../store/actions';
import { reportSearchFilterEvent, TYPES } from '../../../../utils/reports/filter/searchFilter';
import SearchBox from './SearchBox';

const mapStateToProps = ({ filters = {} }) => ({ searchTerm: filters.text });

const mapDispatchToProps = (dispatch) => ({
    onSearch: (value) => {
        dispatch(setSearchTerm(value))
            .then(({ highlightedAmount, textFilterResultsAmount } = {}) => {
                reportSearchFilterEvent(TYPES.searched.successfully, {
                    searchTerm: value,
                    resultsAmount: textFilterResultsAmount,
                    highlightedAmount,
                });
            })
            .catch((error) => {
                reportSearchFilterEvent(TYPES.searched.failed, {
                    searchTerm: value,
                });
                logger.error(error, {
                    func: 'onSearch',
                    component: 'Reviews SearchBox',
                });
            });
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchBox);
